export default {"src":"/_next/static/media/arrow-hero.0544cb9a.svg","height":22,"width":43,"blurWidth":0,"blurHeight":0};